import React, {useState} from 'react'
import TopBanner from './common/TopBanner';
import SignUpForm from './common/SignUpForm';
import icon from './simulcasticon.svg';
// Button replaced with native button
import { auth, firestore } from './common/firebase';
import { createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';

const SignUp = ( {history }) => {

	const [ values, setValues] = useState({});

	const handleChange = name => event => {
		setValues({ ...values, [name]: event.target.value });
	};
	const validateValues = () => {
		return (values.first && values.first.length > 1) 
			&& 
			(values.last && values.last.length > 1)
			&&
			(values.email && values.email.length > 3)
			&&
			(values.password && values.password.length > 0 && values.passwordconfirm && values.passwordconfirm.length)
			&&
			(values.passwordconfirm == values.password);
	}

	const apply = async (evt) => {
		
		if(validateValues()){
			var { password, passwordconfirm, ...rest} = values;
			try {
				const result = await createUserWithEmailAndPassword(auth, values.email, values.password);
				if (result && result.user) {
					rest.stripe_user = "";
					rest.stripe_payment_method = "";
					rest.subscription_token = "";
					rest.subscription_active = false;
					rest.subscription_level = "";
					await setDoc(doc(firestore, "users", result.user.uid), rest);
					await signOut(auth);
					history.push("/login");
				}
			} catch (error) {
				// Handle Errors here.
				var errorCode = error.code;
				var errorMessage = error.message;
				if (errorCode == 'auth/weak-password') {
					alert('The password is too weak.');
				} else {
					alert(errorMessage);
				}
				console.log(error);
			}
		} else {
			alert("Please check your entries and try again");
		}
			
	}
	return (
		<div>
			<TopBanner title="Sign Up for Simulcast" history={history} icon={icon}></TopBanner>
			<SignUpForm history={history} values={values} handleChange={handleChange} applyFunc={apply}></SignUpForm>
		</div>
	);
}

export default SignUp;